import React from 'react';
import { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { Row, Col } from 'react-flexbox-grid';
import TitleBar from '../Layout/titleBar';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { exportarPagosPedidosCsvAsync, obtenerFiltrosEstados } from '../../sagas/PagosYDevolucionesSaga/calls';


const PagosYDevoluciones = ({ usuario }) => {
  const [isExporting, setIsExporting] = useState(false);
  const [filtrosEstado, setFiltrosEstado] = useState([]);
  const [estadoSeleccionado, setEstadoSeleccionado] = useState(null);
  const [isLoadingFilters, setIsLoadingFilters] = useState(true);


  useEffect(() => {
    const cargarFiltros = async () => {
      try {
        setIsLoadingFilters(true);
        const response = await obtenerFiltrosEstados();
        setFiltrosEstado(response);
        setEstadoSeleccionado(response.find(f => f.value === 'ALL'));
      } catch (error) {
        console.error('Error cargando filtros:', error);
      } finally {
        setIsLoadingFilters(false);
      }
    };

    cargarFiltros();
  }, []);


  const handleExportClick = async () => {
    try {
      setIsExporting(true);
      const params = {
        filtroFecha: 'Ultimos30Dias',
        estados: estadoSeleccionado?.statusList || []
      };

      const response = await exportarPagosPedidosCsvAsync(params);
      console.log('debug response',response)

      if (!response) {
        throw new Error('No se recibió respuesta del servidor');
      }

      if (!response.data) {
        throw new Error('Datos de respuesta vacíos');
      }

      const contentDisposition = response.headers?.['content-disposition'] || response.headers?.['Content-Disposition'];
          let filename = 'pagos-pedidos.csv';

      if (contentDisposition) {
        // console.log('Content-Disposition:', contentDisposition);
        
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, '');
        }
      }

    // console.log('Filename extraído:', filename);

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error('Error en handleExportClick:', error);
    } finally {
      setIsExporting(false);
    }
  };

  // if (!usuarioCargado) {
  //   return (
  //     <div style={{ padding: '20px', textAlign: 'center' }}>
  //       <p style={{ fontSize: '1.2rem', marginBottom: '10px' }}>Cargando usuario...</p>
  //       <CircularProgress />
  //     </div>
  //   );
  // }

  if (!usuario) {
    return <div></div>;
  }

  return (
    <div style={{ padding: '20px' }}>
      <TitleBar title="Pagos y Devoluciones" />
      <Row>
        <Col xs={12}  md={4}>
          <TextField
            select
            label="Filtrar por estado"
            value={estadoSeleccionado?.value || ''}
            onChange={(e) => {
              const filtro = filtrosEstado.find(f => f.value === e.target.value);
              setEstadoSeleccionado(filtro);
            }}
            variant="outlined"
            fullWidth
          >
            {filtrosEstado.map((filtro) => (
              <MenuItem key={filtro.value} value={filtro.value}>
                {filtro.label}
              </MenuItem>
            ))}
          </TextField>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Button
            variant="contained"
            className="btnPrincipal"
            onClick={handleExportClick}
            disabled={isExporting || isLoadingFilters}
            style={{
              paddingBottom: isExporting ? '25px' : '10px',
              overflow: 'hidden',
              position: 'relative',
              backgroundColor: '#46c082',
              color: 'white',
              opacity: isExporting || isLoadingFilters ? 0.7 : 1
            }}
          >
            {isExporting ? 'Exportando...' : 'Exportar a CSV'}

            {(isExporting || isLoadingFilters) && (
              <LinearProgress

                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  width: '100%',
                  height: '4px',
                  backgroundColor: '#a8e6bf', 
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: '#388e3c',
                  }
                }}
              />
            )}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default PagosYDevoluciones;